/**
 * AdvisorSummaryWidget
 *
 * Dashboard widget that displays the advisor header with dark blue background.
 */
import { useQuery } from '@apollo/client'
import { LinearProgress } from '@mui/material'

import { Amount, Box, Container, Icons, Text, Tooltip } from '../..'
import { queries } from '../../../graphql'
import { useAdvisorAccess } from '../../../hooks/useAdvisorAccess'

export function AdvisorSummaryWidget() {
  const { data, loading } = useQuery(queries.user.me)
  const { totals, loading: advisorLoading } = useAdvisorAccess()
  const advisorName = data?.me?.name || ''

  if (loading || advisorLoading) {
    return <LinearProgress />
  }

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: 'secondary.main',
        mt: 'calc(-1 * var(--6))',
        py: 3,
      }}
    >
      <Container maxWidth="lg" sx={{ mb: 0 }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Text.H4 color="secondary.contrastText">{advisorName || 'Advisor Dashboard'}</Text.H4>
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <Balance
              Icon={Icons.Account}
              amount={totals?.totalBalance || 0}
              tooltip="Combined total value across all client funds"
            />
            <Balance
              Icon={Icons.Wallet}
              amount={totals?.givingWalletBalance || 0}
              tooltip="Combined giving wallet balance across all client funds"
            />
            <Balance
              Icon={Icons.Investments}
              amount={totals?.investmentWalletBalance || 0}
              tooltip="Combined investment account balance across all client funds"
            />
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

function Balance({ Icon, amount, tooltip }) {
  return (
    <Tooltip title={tooltip}>
      <Text.Body
        sx={{
          fontSize: '1.25rem',
          color: 'secondary.contrastText',
          display: 'flex',
          mr: 4,
          alignItems: 'center',
          padding: '4px 8px',
          borderRadius: '4px',
        }}
      >
        <Icon style={{ marginRight: '.5rem', fontSize: '1rem' }} />
        <Amount value={amount} />
      </Text.Body>
    </Tooltip>
  )
}
